var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.93 9.53c1.15-3.32-5.68-6.63-7.4-2.84l-1.74 2.68a9.06 9.06 0 0 1 8.33 3.41l.8-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.12 35.59A9.74 9.74 0 0 1 10.71 43 9.77 9.77 0 0 1 1 33.16c0-4.98 6.94-20.09 6.94-20.09 3.76-4.69 12.03-2.17 13.15 2.83 0 0 .29 1.51.71 3.2a5.4 5.4 0 0 1 2.06-.38c.76 0 1.48.14 2.12.4.54-1.7.93-3.22.93-3.22 1.12-5 9.39-7.52 13.15-2.83 0 0 6.94 15.11 6.94 20.1A9.77 9.77 0 0 1 37.3 43a9.74 9.74 0 0 1-9.42-7.41l.01.56h-.02A3.9 3.9 0 0 1 24 39.68a3.9 3.9 0 0 1-3.87-3.53h-.02l.01-.56Zm6.21.17c0 1.3-1.04 2.35-2.33 2.35a2.34 2.34 0 0 1-2.33-2.35c0-1.3 1.04-2.34 2.33-2.34a2.34 2.34 0 0 1 2.33 2.34Zm-9.65-2.26a6.3 6.3 0 0 1-6.27 6.33 6.3 6.3 0 0 1-6.27-6.33 6.3 6.3 0 0 1 6.27-6.33 6.3 6.3 0 0 1 6.27 6.33Zm20.91 6.33a6.3 6.3 0 0 0 6.27-6.33 6.3 6.3 0 0 0-6.27-6.33 6.3 6.3 0 0 0-6.27 6.33 6.3 6.3 0 0 0 6.27 6.33Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.07 9.53c-1.15-3.32 5.68-6.63 7.4-2.84l1.74 2.68a9.06 9.06 0 0 0-8.33 3.41l-.8-3.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.443d26975e03e297a637534312e3d818.svg";
export { ForwardRef as ReactComponent };